import useRequest, {
    RequestFn,
    RequestKeys,
} from 'app/hooks/useRequest'

import longTermLeaseInvoicesRequests from '../LongTermLeaseInvoices.request'

const useGetLongTermLeaseInvoices = ({
    longTermLeaseId,
}: {
    longTermLeaseId: number,
}) => {
    return useRequest({
        key: RequestKeys.getLongTermLeaseInvoices,
        params: {
            longTermLeaseId,
            data: {
                rows: 500,
            },
        },
        requestFunc: RequestFn.getEntity(longTermLeaseInvoicesRequests.filterRequestAll,
            async (promise) => {
                const resp: {
                    data,
                } = await promise

                return resp?.data?.items
            }),
        enabled: Boolean(longTermLeaseId),
    })
}

export default useGetLongTermLeaseInvoices
